const END_TOLERANCE_SEC = 0.05;

/** Return only the buffered range that actually contains the playhead. */
function rangeAtPlayhead(video) {
    try {
        const time = video?.currentTime;
        const ranges = video?.buffered;
        if (!Number.isFinite(time) || time < 0 || !ranges?.length) return null;

        for (let index = 0; index < ranges.length; index += 1) {
            const start = ranges.start(index);
            const end = ranges.end(index);
            if (!Number.isFinite(start) || !Number.isFinite(end) || end < start) continue;
            // A nearby future range is not playable buffer before its start.
            if (start <= time && time <= end) return { time, end };
        }
    } catch {
        // Media ranges can change or become unavailable during a source switch.
    }
    return null;
}

/** Seconds buffered continuously ahead of the current position; zero in a gap. */
export function bufferedAhead(video) {
    const range = rangeAtPlayhead(video);
    return range ? Math.max(0, range.end - range.time) : 0;
}

/** Whether the range containing the playhead reaches this finite clip's end. */
export function isBufferedToEnd(video) {
    try {
        const duration = video?.duration;
        if (!Number.isFinite(duration) || duration <= 0) return false;
        const range = rangeAtPlayhead(video);
        return Boolean(range && range.end >= duration - END_TOLERANCE_SEC);
    } catch {
        return false;
    }
}

/**
 * Find the first available unique URL in ladder order, excluding the current URL.
 * unavailableSet belongs to the caller's playback attempt; neither input mutates.
 * A manual retry can pass a new Set to allow previously unavailable URLs again.
 */
export function nextSourceIndex(ladder, currentIndex, unavailableSet = new Set()) {
    if (!Array.isArray(ladder)) return -1;
    const currentUrl = ladder[currentIndex];
    const seen = new Set();

    for (let index = 0; index < ladder.length; index += 1) {
        const url = ladder[index];
        if (typeof url !== "string" || !url.trim() || seen.has(url)) continue;
        seen.add(url);
        if (url !== currentUrl && !unavailableSet.has(url)) return index;
    }
    return -1;
}
